module.exports = __webpack_public_path__ + "img/portugal.8bccdaa6.png";